import type { JobFormValues } from "@js/types/jobs";

export const MAX_CRITERIA_ITEMS_COUNT = 10;

export const gradingCriteriaValidator = (
  _value: unknown,
  allValues: JobFormValues,
) => {
  const { interview_criteria, is_ai_interview_enabled } = allValues;

  if (is_ai_interview_enabled && interview_criteria?.length === 0) {
    return `Grading criteria must have a minimum of 1 and maximum of ${MAX_CRITERIA_ITEMS_COUNT} criteria.`;
  }
};

export const MAX_QUESTIONS_COUNT = 5;

export const questionsValidator = (
  _value: unknown,
  allValues: JobFormValues,
) => {
  const { interview_questions, is_ai_interview_enabled } = allValues;

  if (!is_ai_interview_enabled) {
    return;
  }

  if (!interview_questions || interview_questions?.length === 0) {
    return `AI interview must have a minimum of 1 question and maximum of ${MAX_QUESTIONS_COUNT} questions.`;
  }
};
